import axios from 'axios'

export interface GalleryApiError {
  status: number | null
  /** Stable machine-readable error code, see GalleryApiErrorCode. */
  code: string | null
  message: string | null
  errors: Record<string, string[]>
  remainingBytes: number | null
  /** Upload state reported with upload_not_open: aborted, expired, rejected or completed. */
  uploadStatus: string | null
}

interface ErrorBody {
  message?: unknown
  code?: unknown
  errors?: unknown
  remaining_bytes?: unknown
  status?: unknown
}

function isRecordOfArrays(value: unknown): value is Record<string, string[]> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

/** Normalises an axios error from the gallery endpoints. Never parses message text. */
export function parseGalleryApiError(error: unknown): GalleryApiError {
  const empty: GalleryApiError = { status: null, code: null, message: null, errors: {}, remainingBytes: null, uploadStatus: null }
  if (!axios.isAxiosError(error)) return empty

  const body = (error.response?.data ?? {}) as ErrorBody
  return {
    status: error.response?.status ?? null,
    code: typeof body.code === 'string' ? body.code : null,
    message: typeof body.message === 'string' ? body.message : null,
    errors: isRecordOfArrays(body.errors) ? body.errors : {},
    remainingBytes: typeof body.remaining_bytes === 'number' ? body.remaining_bytes : null,
    uploadStatus: typeof body.status === 'string' ? body.status : null,
  }
}
